import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../../shared/button/Btn"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import InputCaseTypeSelect from "../../shared/input/new/InputCaseTypeSelect"
import InputSelect from "../../shared/input/new/InputSelect"
import InputText from "../../shared/input/new/InputText"
import InputPhoneFormat from "../../shared/input/new/InputPhoneFormat"
import InputDate from "../../shared/input/new/InputDate"
import PageTopTitle from "../../shared/PageTopTitle"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import InputNewAracTypeSelect from "../../shared/input/new/InputNewAracTypeSelect"
import InputNumberWithSuffix from "../../shared/input/new/InputNumberWithSuffix"
import InputNumberNew from "../../shared/input/new/InputNumberNew"
import { updateRentalCarSeekers } from "../../../features/ilanlar/ilanlarSlice"
import moment from "moment"
import InputTextarea from "../../shared/input/new/InputTextarea"
import { getAracTypes } from "../../../features/adminSett/adminSettSlice"
import locationCityList from "../../../utils/locationData/locationCityOptions"
import InputSelectCityMultiple from "../../shared/input/new/InputSelectCityMulti"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 800px;
        height: 700px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        padding-top: 20px;
        align-items: center;
        overflow: auto;
        position: relative;
        .content{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            .inputs{
                display: flex;
                flex-direction: column;
                gap: 15px;
                width: 70%;
                margin-top: 30px;
                padding-inline: 30px;
                .row{
                    width: 100%;
                }
            }

            .btn-group{
                display: flex;
                align-items: center;
                margin-top: 20px;
                position: sticky;
                bottom: 0;
                justify-content: center;
                background-color: white;
                gap: 15px;
                width: 100%;
                z-index: 10;
                height: 60px;
            }
        }
        
    }

`

const takografData = [
    {
        id:1,
        text: "Uyumlu",
        value: true
    },
    {
        id:2,
        text: "Uyumsuz",
        value: false
    }
]

const driverData = [
    {
        id: 0,
        text: "Sürücüsüz",
    },
    {
        id: 1,
        text: "Tek Sürücü",
    },
    {
        id: 2,
        text: "Çift Sürücü",
    }
]
 
const UpdateRentalCarSeekerModal = () => {

    const {modalLocation } = useSelector(state => state.modal)
    const { selectRentalCar } = useSelector(state => state.ilanlar)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();
    const {aracTypes } = useSelector(state => state.adminSett)


    useEffect(() => {
        dispatch(getAracTypes())
    }, [])
    

    const [selectedTruckType, setSelectedTruckType] = useState(aracTypes?.find(item => item.name === selectRentalCar?.vehicleType))
    const [initialCaseType, setInitialCaseType] = useState(aracTypes?.find(item => item.name === selectRentalCar?.vehicleType)?.trailerTypesModel?.$values)
    const [selectedCaseType, setSelectedCaseType] = useState(initialCaseType?.find(item => item?.name === selectRentalCar?.bodyType))
    const [selectedCity, setSelectedCity] = useState([])
    const [phoneToCall, setPhoneToCall] = useState("")
    const [driverType, setDriverType] = useState(driverData?.find(item => item.id === selectRentalCar?.id))
    const [takografStatus, setTakografStatus] = useState(selectRentalCar?.isTachograph ? takografData[0] : takografData[1])

    const [data, setData] = useState({
        title: selectRentalCar?.title,
        vehicleCount: selectRentalCar?.vehicleCount,
        loadType: selectRentalCar?.loadType,
        ortKm: selectRentalCar?.monthlyAverageKm,
        workRoute: selectRentalCar?.workRoute,
        fuelPercentage: selectRentalCar?.fuelPercentage,
        rentalPrice: selectRentalCar?.rentalPrice,
        paymentMethod: selectRentalCar?.paymentMethod,
        rentTime: selectRentalCar?.contractDuration,
        holidays: selectRentalCar?.holidayDays,
        description: "",
        advertEndDate: moment(selectRentalCar?.advertEndDate).format("YYYY-MM-DD"),
    })

    useEffect(() => {
        if (locationCityList.length > 0) {
          const filteredCities = locationCityList.filter(city =>
            selectRentalCar.truckVehicleWorkCities.$values.some(data => data.cityId === parseInt(city.cityId))
          );
            setSelectedCity(filteredCities);
        }
    }, [selectRentalCar, locationCityList]);

    useEffect(() => {
        if (selectRentalCar?.advertOwnerPhoneNumber) {
            const formattedPhoneNumber = (selectRentalCar?.advertOwnerPhoneNumber.startsWith("+90") || selectRentalCar?.advertOwnerPhoneNumber.startsWith("90")) ? `${selectRentalCar?.advertOwnerPhoneNumber}` : `90${selectRentalCar?.advertOwnerPhoneNumber}`;
            setPhoneToCall(formattedPhoneNumber);
        }
    }, []);

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleChange = (e) => {
        setData((prev) => ({...prev, [e.target.name]: e.target.value}))
    }

    const stringToNum = (item) => {
        const numericString = item?.replace(/\D/g, "");
        const intValue = parseInt(numericString);
        return intValue
    }

    const handleSubmit = () => {
        const addData = {
            "id": selectRentalCar?.id,
            "title": data.title, // İlan başlığı
            "vehicleType": selectedTruckType?.name, // Araç tipi
            "bodyType": selectedCaseType?.name, // Araç gövde tipi
            "vehicleCount": data.vehicleCount, // Araç sayısı
            "driverType": driverType?.id, // 0 Sürücüsüz/ 1 Tek Sürücü/ 2 Çift Sürücü
            "rentVehicleNewWorkCities": selectedCity?.map(item => {
                return {
                    city: item.city,
                    cityId: parseInt(item.cityId)
                }
            }), // Çalışılacak il
            "workRoute": data?.workRoute, // Çalışılacak güzergah
            "loadType": data?.loadType, // Yükün cinsi
            "fuelPercentage": (typeof data?.fuelPercentage === "number") ? data?.fuelPercentage : stringToNum(data?.fuelPercentage), // Yakıt yüzdesi
            "monthlyAverageKm": (typeof data?.ortKm === "number") ? data?.ortKm : stringToNum(data?.ortKm), // Aylık ortalama kilometre
            "rentalPrice": (typeof data?.rentalPrice === "number") ? data?.rentalPrice : stringToNum(data?.rentalPrice), // Kira bedeli
            "paymentMethod": data?.paymentMethod, // Ödeme şekli
            "contractDuration": parseInt(data?.rentTime), // Sözleşme süresi (ay olarak)
            "isTachograph": takografStatus?.value, // Takograf uyumlu mu
            "holidayDays": data?.holidays, // Tatil günleri
            "advertEndDate": data?.advertEndDate, // İlan bitiş tarihi
            "advertOwnerPhoneNumber": phoneToCall.startsWith("+90") ? phoneToCall.slice(2) : phoneToCall // İlan sahibi telefon numarası
        }
        
        dispatch(updateRentalCarSeekers(addData))
    }

  return (
    <Container onClick={() => dispatch(showModal(null)) }>
        <div className="modal" onClick={(e)=>{e.stopPropagation(); dispatch(handleActiveSelect(null))}} >
            <PageTopTitle isDiffPage title={"İlan Güncelle"}/>

            <div className="content">
                <div className="inputs">
                    <div className="row">
                        <InputText data={data?.title} setData={(e) => handleChange(e)} name={"title"} labelText={"İlan Başlığı"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputNumberNew data={data?.vehicleCount} setData={(e) => handleChange(e)} name={"vehicleCount"} inputWidth={"100%"} labelText={"Araç Sayısı"} />
                    </div>
                    <div className="row">
                        <InputNewAracTypeSelect setInitialCaseType={setInitialCaseType} data={selectedTruckType} setData={setSelectedTruckType} labelText={"Araç Tipi"} name={"selectedTruckType"} initialOptions={aracTypes} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputCaseTypeSelect initialOptions={initialCaseType} data={selectedCaseType} setData={setSelectedCaseType} labelText={"Kasa Tipi"} name={"selectedCaseType"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputSelect initialOptions={driverData} data={driverType?.text} setData={setDriverType} name={"driverType"} inputWidth={"100%"} labelText={"Sürücü Sayısı"} />
                    </div>
                    <div className="row">
                        <InputSelectCityMultiple data={selectedCity} setData={setSelectedCity} labelText={"Çalışacak İl / İller"} initialOptions={locationCityList} inputWidth={"100%"} name={"iller"}/>
                    </div>
                    <div className="row">
                        <InputText data={data?.workRoute} setData={(e) => handleChange(e)} name={"workRoute"} labelText={"Çalışılmak İstenilen Güzergah"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputText data={data?.loadType} setData={(e) => handleChange(e)} name={"loadType"} labelText={"Yükün Türü"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputNumberWithSuffix suffix={" %"} noneSeperator data={data?.fuelPercentage} setData={(e) => handleChange(e)} name={"fuelPercentage"} labelText={"Yakıt Yüzdesi"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputNumberWithSuffix suffix={" Km"} noneSeperator data={data?.ortKm} setData={(e) => handleChange(e)} name={"ortKm"} labelText={"Aylık Ortalama Km"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputText data={data?.paymentMethod} setData={(e) => handleChange(e)} name={"paymentMethod"} labelText={"Ödeme Şekli"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputNumberWithSuffix suffix={" TL"} data={data?.rentalPrice} setData={(e) => handleChange(e)} name={"rentalPrice"} labelText={"Aylık Kira Bedeli (KDV Hariç)"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputNumberNew data={data?.rentTime} setData={(e) => handleChange(e)} name={"rentTime"} inputWidth={"100%"} labelText={"Kiralama Süresi (Ay)"} />
                    </div>
                    <div className="row">
                        <InputSelect initialOptions={takografData} data={takografStatus?.text} setData={setTakografStatus} name={"takografStatus"} labelText={"Takograf Uyumlu Mu?"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputText data={data?.holidays} setData={(e) => handleChange(e)} name={"holidays"} labelText={"Tatil Günleri"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputTextarea data={data?.description} setData={(e) => handleChange(e)} name={"description"} labelText={"Açıklama"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputPhoneFormat data={phoneToCall} setData={setPhoneToCall} name={"phoneToCall"} labelText={"İlan için Aranacak telefon"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputDate data={data?.advertEndDate} setData={(e) => handleChange(e)} labelText={"İlan Bitiş Tarihi"} name={"advertEndDate"} inputWidth={"100%"} />
                    </div>
                </div>
                <div className="btn-group">
                    <Button width="150px" handleClick={handleSubmit} padding="10px" background="#fff" color={"#E85446"}>Güncelle</Button>
                    <Button width="150px" handleClick={() => dispatch(showModal(null))} padding="10px" background="#fff" color={"#E85446"}>Kapat</Button>
                </div>
            </div>
        </div>
    </Container>
  )
}

export default UpdateRentalCarSeekerModal